<div class="table-basket-container">
  <table
    [dataSource]="dataSource"
    aria-label="This table displays the cart items"
    class="table-cart"
    mat-table>
    <ng-container matColumnDef="fragrance">
      <th *matHeaderCellDef mat-header-cell>
        {{ 'popin-header.fragrance' | translate }}
      </th>
      <td *matCellDef="let element" class="fragrance-cell" mat-cell>
        <div class="cart-fragrance">
          <img
            [ngSrc]="element.imageUrl"
            alt="fragrance"
            class="cart-fragrance-image"
            loading="lazy"
            height="74"
            width="74" />
          <p class="basket-fragrance body-m-bold">{{ element.name }}</p>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th *matHeaderCellDef mat-header-cell>
        {{ 'popin-header.type' | translate }}
      </th>
      <td *matCellDef="let element" class="type-cell" mat-cell>
        {{ element.options[0]?.value }}
      </td>
    </ng-container>

    <ng-container matColumnDef="qty">
      <th *matHeaderCellDef class="qte-align" mat-header-cell>
        {{ 'popin-header.qty' | translate }}
      </th>
      <td *matCellDef="let element" class="qty-cell" mat-cell>
        @if(element.options[0]?.value.toLowerCase() !== CartVariants.sample) {
          <app-plus-minus-button
          (quantityEmitEvent)="
            updateCart(element.productId, element.id, $event)
          "
          [minQuantity]="element.packaging"
          [quantity]="element.quantity">
          </app-plus-minus-button>
        }
        @else {
          {{ element.quantity }}
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="unit-price">
      <th *matHeaderCellDef mat-header-cell>
        <span class="body-m-bold">{{
          'popin-header.unit-price' | translate
        }}</span
        ><br />
        <span class="body-xs">{{
          'popin-header.vat' | translate : { volumeUnit: accountService.user().volumeUnit }
        }}</span>
      </th>
      <td *matCellDef="let element" class="price-cell" mat-cell>
        <ng-container *ngIf="element.listPrice === 0; else price">
          Free
        </ng-container>
        <ng-template #price>
          {{ element.listPrice | defaultCurrency }}</ng-template
        >
      </td>
    </ng-container>
    <ng-container matColumnDef="total">
      <th *matHeaderCellDef mat-header-cell>
        {{ 'popin-header.total' | translate }}
      </th>
      <td *matCellDef="let element" class="price-cell" mat-cell>
        <ng-container *ngIf="element.extendedListPrice === 0; else price">
          -
        </ng-container>
        <ng-template #price>
          {{ element.extendedListPrice | defaultCurrency }}</ng-template
        >
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let element" class="actions-cell" mat-cell>
        <button
          (click)="updateCart(null, element.id, null)"
          [attr.aria-label]="'cart.remove-aria-label' | translate"
          class="product-cell__remove">
          <mat-icon class="trash">delete</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  </table>
</div>
